// Admin do canal ScontiPoste
const adminChannelDictPT = {
  adminChannelMenu: "ScontiPoste",
  adminChannelTabConfig: "Configuração",
  adminChannelTabSellers: "Managers",
  adminChannelTabSales: "Vendas",
  adminChannelTabCashback: "Provisão de cashback",
  adminChannelUrl: "Link da vitrine",
  adminChannelUrlHelp: "Este é o link que a ScontiPoste publica. Para saber de onde vêm as vendas, passe o link com UTMs.",
  adminChannelUtmUrl: "Link com UTMs",
  adminChannelOpen: "Abrir vitrine",
  adminChannelStatus: "Situação",
  adminChannelActive: "Vitrine aberta ao público",
  adminChannelInactive: "Vitrine fechada",
  adminChannelPercent: "Cashback ScontiPoste (%)",
  adminChannelPercentHelp: "Descontado do vendedor em cada venda. Vale só para pedidos novos.",
  adminChannelSave: "Salvar",
  adminChannelSaved: "Configuração salva",
  adminChannelActiveSellers: "Managers ativos: {count}",
  adminChannelOutdated: "{count} Manager(s) ainda não aceitaram o % atual: os produtos deles estão fora da vitrine.",
  adminChannelConfirmPercentTitle: "Mudar o cashback?",
  adminChannelConfirmPercent: "O cashback passa de {from}% para {to}%. Os {count} Managers ativos precisam aceitar o novo % no painel deles; até lá, os produtos deles saem da vitrine.",
  adminChannelConfirmPercentAction: "Mudar para {to}%",
  adminChannelSeller: "Manager",
  adminChannelJoined: "Adesão",
  adminChannelTermsPercent: "% aceito",
  adminChannelProductsMode: "Produtos",
  adminChannelAllProducts: "Loja inteira",
  adminChannelSelectedProducts: "Selecionados",
  adminChannelListed: "Na vitrine",
  adminChannelSellerStatus: "Situação",
  adminChannelStatusActive: "Ativo",
  adminChannelStatusOutdated: "Aceite pendente",
  adminChannelStatusLeft: "Fora do canal",
  adminChannelSuspend: "Suspender",
  adminChannelReactivate: "Reativar",
  adminChannelSuspendTitle: "Suspender Manager?",
  adminChannelSuspendConfirm: "Os produtos de {name} saem da vitrine ScontiPoste na hora. Os pedidos já feitos seguem normalmente.",
  adminChannelSearchSellers: "Buscar Manager",
  adminChannelFrom: "De",
  adminChannelTo: "Até",
  adminChannelApply: "Filtrar",
  adminChannelCheckout: "Checkout",
  adminChannelDate: "Data",
  adminChannelBuyer: "Comprador",
  adminChannelOrders: "Pedidos",
  adminChannelTotal: "Total",
  adminChannelOrigin: "Origem",
  adminChannelNoOrigin: "Sem UTM",
  adminChannelCheckoutPAID: "Pago",
  adminChannelCheckoutCREATED: "Não concluído",
  adminChannelCheckoutFAILED: "Falhou",
  adminChannelCheckoutREFUNDED: "Estornado",
  adminChannelCheckoutPARTIALLY_REFUNDED: "Estorno parcial",
  adminChannelPaidTotal: "Total pago no período: {total}",
  adminChannelSearchSales: "Buscar comprador, pedido ou campanha",
  adminChannelCashbackHelp: "Cashback descontado dos vendedores no recebimento dos pedidos. Use para conferir a fatura da Poste Italiane.",
  adminChannelCashbackTotal: "Total provisionado no período: {total}",
  adminChannelExportCsv: "Exportar CSV",
  adminChannelBySeller: "Por Manager",
  adminChannelOrder: "Pedido",
  adminChannelAmount: "Valor",
  adminChannelOrderAmount: "Valor dos itens",
  adminChannelSearchCashback: "Buscar Manager ou pedido",
  adminChannelEntryACCRUED: "Provisionado",
  adminChannelEntryREVERSED: "Estornado",
  channelError500439: "O cashback deve ficar entre 0 e 100, com até 2 casas decimais.",
  channelError500440: "Defina um cashback maior que 0 antes de abrir a vitrine.",
};

export default adminChannelDictPT;
